import PropTypes from 'prop-types';
// -*- mode: jsx;-*-

import CategorySelector from './CategorySelector.js';

export default function CategorySelectors({
    supportCategories, tierSelectedSupportCategories,
    formErrors, callbacks,
}) {
    const hasError = !!formErrors.supportCategoryId;
    const hasTierOneError = hasError && (!tierSelectedSupportCategories || !tierSelectedSupportCategories.tierOneSelectedCategory);
    const hasTierTwoError = hasError && !tierSelectedSupportCategories.tierTwoSelectedCategory;

    return (
        <div className="input-holder">
            <label htmlFor="tierOneSelector">What can we help you with?</label>
            <CategorySelector
                selectorId="tierOneSelector"
                supportCategories={supportCategories.tierOneSupportCategories}
                selectedCategory = {tierSelectedSupportCategories.tierOneSelectedCategory}
                updateCategory={callbacks.updateTierOneCategory}
                defaultText="Select an issue"
                hasError={hasTierOneError}
            />
            <CategorySelector
                selectorId="tierTwoSelector"
                supportCategories={supportCategories.tierTwoSupportCategories}
                selectedCategory = {tierSelectedSupportCategories.tierTwoSelectedCategory}
                updateCategory={callbacks.updateTierTwoCategory}
                defaultText="Select issue details"
                hasError={hasTierTwoError}
            />
            <CategorySelector
                selectorId="tierThreeSelector"
                supportCategories={supportCategories.tierThreeSupportCategories}
                selectedCategory = {tierSelectedSupportCategories.tierThreeSelectedCategory}
                updateCategory={callbacks.updateTierThreeCategory}
                defaultText="Select additional details"
                hasError={hasError}
            />
            {hasError ? (<div className="error-text">{formErrors.supportCategoryId}</div>) : null}
        </div>
    );
}
CategorySelectors.propTypes = {
    supportCategories: PropTypes.object.isRequired,
    tierSelectedSupportCategories: PropTypes.object,
    formErrors: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
};
